<div class="container">
  <form>
    <h1 class="mb-1 text-center" mat-dialog-title>Select Asset</h1>
    <mat-divider class="divider mb-1"></mat-divider>
    <mat-dialog-content class="text-center">
      <mat-form-field>
        <mat-select name="assetType" placeholder="Select Asset Type" [(ngModel)]="vm.selectedAssetType">
          <mat-option *ngFor="let assetTypeValue of vm.assetType; trackBy: trackByAsset" [value]="assetTypeValue">
            {{ assetTypeValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>

    <div class="d-flex justify-content-center">
      <mat-dialog-actions>
        <button
          class="create-button"
          mat-button
          mat-raised-button
          type="submit"
          (click)="createAsset(vm.selectedAssetType)"
        >
          Create
        </button>
        <button mat-button type="button" (click)="onCloseDialog()">Close</button>
      </mat-dialog-actions>
    </div>
  </form>
</div>
